import { isNonEmptyArray } from '../typeValidation/basicGuards.js';
import '../typeValidation/booking.js';
import 'lodash-unified';
import '../typeValidation/draftWaypoint.js';
import '../typeValidation/feedback.js';
import '../environment/crypto/index.js';
import 'dayjs';
import '@caresend/types';
import 'immutability-helper';
import '../formatters/string.js';
import 'ngeohash';
import '../formatters/location.js';
import '../initializers/user.js';
import '../typeValidation/note.js';
import '../typeValidation/procedure.js';
import '../typeValidation/samples.js';
import '../typeValidation/shift.js';
import '../typeValidation/shipmentInfo.js';
import '../typeValidation/supply.js';
import '../typeValidation/timeSlot.js';
import '../typeValidation/waypoint.js';
import '../typeValidation/waypointAction.js';

/**
 * Example:
 *
 * ```
 * {
 *   '1': { id: '1', timestamp: 1718181818000 },
 *   '2': { id: '2', timestamp: 1718181819000 }
 * }
 * ```
 *
 * ⬇️
 *
 * ```
 * { id: '2', timestamp: 1718181819000 }
 * ```
 */

const getLatestInListTimestamp = listTimestamp => {
  const elementTimestamps = Object.values(listTimestamp);
  if (!isNonEmptyArray(elementTimestamps)) return undefined;
  return elementTimestamps.reduce((latest, current) => current.timestamp > (latest === null || latest === void 0 ? void 0 : latest.timestamp) ? current : latest, elementTimestamps[0]);
};
/**
 * Compares two ListTimestamp objects to check if they contain the same IDs.
 * Returns true if both objects have the same set of IDs, false otherwise.
 *
 * @param list1 - First ListTimestamp object
 * @param list2 - Second ListTimestamp object
 * @returns boolean indicating whether the lists contain the same IDs
 */

const getListTimestampsIDsMatch = (list1, list2) => {
  const ids1 = Object.keys(list1);
  const ids2 = Object.keys(list2);
  if (ids1.length !== ids2.length) return false;
  return ids1.every(id => Object.prototype.hasOwnProperty.call(list2, id));
};

export { getLatestInListTimestamp, getListTimestampsIDsMatch };
